import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { fb } from './firebase/firebaseConfig'
import vuetify from './plugins/vuetify';
import './assets/css/main-b03e2b000f.a4ceb669.css'

Vue.config.productionTip = false

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
